var exports = {
  "wx": "PremiumBadgeSettings.module__header___RVVPeF",
  "DD": "PremiumBadgeSettings.module__title___RVVPeF",
  "h_": "PremiumBadgeSettings.module__description___RVVPeF",
  "n$": "PremiumBadgeSettings.module__switches___RVVPeF",
};

module.exports = exports;
